// Nova Aura (rediseño 2026-10-07): recomendaciones del cajón de carrito.
// Añade con el mismo flujo que la ficha (POST /cart/add + evento estándar CartLinesUpdateEvent) para que
// el cajón, el contador de la bolsa y las analíticas se actualicen igual que con "Agregar al carrito".
import { CartLinesUpdateEvent } from '@shopify/events';

const SECTION_ID = 'cart-drawer-section';

document.addEventListener('click', async (event) => {
  const target = /** @type {HTMLElement} */ (event.target);

  const arrow = target.closest('.nova-upsell__arrow');
  if (arrow) {
    const track = arrow.closest('.nova-upsell')?.querySelector('.nova-upsell__track');
    if (track) track.scrollBy({ left: (arrow.classList.contains('nova-upsell__arrow--prev') ? -1 : 1) * track.clientWidth, behavior: 'smooth' });
    return;
  }

  const button = target.closest('.nova-upsell__add');
  if (!button || button.hasAttribute('disabled')) return;
  const slide = button.closest('.nova-upsell__slide');
  const input = /** @type {HTMLInputElement | HTMLSelectElement | null} */ (slide?.querySelector('.nova-upsell__variant'));
  const id = input?.value;
  if (!id) return;

  button.setAttribute('disabled', '');
  const original = button.textContent;
  button.textContent = '…';

  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: id, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const body = new FormData();
    body.append('id', id);
    body.append('quantity', '1');
    body.append('sections', SECTION_ID);
    // 2026-11-01: rutas con el idioma actual (/fr/...) para que el cajón se vuelva a pintar en ese idioma
    const routes = (typeof Theme !== 'undefined' && Theme.routes) || {};
    const addUrl = routes.cart_add_url || '/cart/add.js';
    const cartUrl = (routes.cart_url || '/cart') + '.js';
    const response = await fetch(addUrl, { method: 'POST', body, headers: { Accept: 'application/json' } }).then((r) => r.json());
    const ajaxCart = await fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
      detail: {
        items: ajaxCart.items,
        source: 'nova-cart-upsell',
        sourceId: 'nova-cart-upsell',
        itemCount: 1,
        sections: response.sections,
        didError: Boolean(response.status),
      },
    });
  } catch (error) {
    deferred.reject(error);
    button.removeAttribute('disabled');
    button.textContent = original;
  }
});
